module.exports = __webpack_public_path__ + "0164b7410b5b0ed65aeb49671b297807.svg";